export default __webpack_public_path__ + "static/media/030-lollipop.59b29970.svg";